/* eslint-disable react/jsx-no-target-blank */
import { Link } from "react-router-dom";
import { connect } from "react-redux";

//custom imports:
import { selectConfiguration } from "@src/store/selectors";
//styles:
import "@src/scss/components/Footer.scss";

//images:
import facebookIcon from "@src/assets/icons/facebook.svg";
import instagramIcon from "@src/assets/icons/insta.svg";
import pinterestIcon from "@src/assets/icons/pinterest.svg";
import twitterIcon from "@src/assets/icons/twitter.svg";
import kookuIcon from "@src/assets/logo.svg";

const FooterView = ({ config }) => {
  if (!config) return null;

  const links = config.links;

  return (
    <div className="core-footer">
      <div className="footer-wrapper">
        <div className="logo">
          <img src={kookuIcon} alt="logo" />
        </div>
        <div className="trademarks">
          <div className="kookoo">{config?.names?.footername}</div>
          {/* <div className="mobiotics">Powered by Mobiotics</div> */}
        </div>
        <ul className="links">
          <li>
            <Link className="core-link" to="/about">
              about
            </Link>
          </li>
          <li>
            <a className="core-link"  href={links.privacy}>
              privacy policy
            </a>
          </li>
          <li>
            <Link className="core-link" to="/contact">
              contact us
            </Link>
          </li>
          <li>
            <Link className="core-link" to="/faq">
              FAQs
            </Link>
          </li>
          <li>
            <a className="core-link"  href="/terms_and_conditions.html">
              Terms And Conditions
            </a>
          </li>
        </ul>
        <ul className="social-icons">
          <li>
            <a target="_blank" rel="noreferrer" href={links.facebook}>
              <img src={facebookIcon} alt="Facebook" />
            </a>
          </li>
          <li>
            <a target="_blank" rel="noreferrer" href={links.instagram}>
              <img src={instagramIcon} alt="Instgram" />
            </a>
          </li>
          {/* <li>
            <a target="_blank" rel="noreferrer" href={links.pinterest}>
              <img src={pinterestIcon} alt="Pinterest" />
            </a>
          </li> */}
          {/* <li>
            <a target="_blank" rel="noreferrer" href={links.twitter}>
              <img src={twitterIcon} alt="Twitter" />
            </a>
          </li> */}
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  config: selectConfiguration(state),
});

const Footer = connect(mapStateToProps)(FooterView);

export { Footer };
